export const GET_FLAGS_ACTIVITIES_REQUEST = "GET_FLAGS_ACTIVITIES_REQUEST";
export const GET_FLAGS_ACTIVITIES_SUCCESS = "GET_FLAGS_ACTIVITIES_SUCCESS";
export const GET_FLAGS_ACTIVITIES_FAILURE = "GET_FLAGS_ACTIVITIES_FAILURE";
